import {
	GiftCardsLokiKey,
	logGiftCardsLokiError,
} from '@/lib/loki-logger/log-gift-cards-loki';
import type { NativeDataError } from '@/lib/pwa/app-data';
import { syncAppData } from '@/lib/pwa/app-data';
import { syncNativeClientTheme } from '@/utils/app-context/client';
import type { CookieHelpers } from '@/utils/cookie';

let initialization: Promise<void> | undefined;

function reportError({ stage, reason }: NativeDataError) {
	// Bridge payloads and launch queries can contain credentials.
	logGiftCardsLokiError(
		GiftCardsLokiKey.NATIVE_SYNC_FAILED,
		new Error(reason),
		{
			stage,
			url: `${window.location.origin}${window.location.pathname}`,
		},
	);
}

/** Once per gift-card webview load. Package consumers still own their runtime. */
export function syncGiftCardAppData(cookies: CookieHelpers): Promise<void> {
	if (
		typeof window === 'undefined' ||
		!/^\/ixi-finance\/gift-cards(?:\/add)?\/?$/.test(window.location.pathname)
	) {
		return Promise.resolve();
	}
	initialization ??= syncAppData({ cookies, onError: reportError }).then(() =>
		syncNativeClientTheme().catch(() =>
			reportError({
				stage: 'theme',
				reason: 'Unable to synchronize native client theme',
			}),
		),
	);
	return initialization;
}
